import Vue from 'vue'
import delayHydration from './hydration/hydrationRace.mjs'

import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_217e657c from 'nuxt_plugin_plugin_217e657c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_7c032ff2 from 'nuxt_plugin_plugin_7c032ff2' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_markdownit_f9cec9a8 from 'nuxt_plugin_markdownit_f9cec9a8' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_apollomodule_6c90045e from 'nuxt_plugin_apollomodule_6c90045e' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_image_5dd6e78d from 'nuxt_plugin_image_5dd6e78d' // Source: ./image.js (mode: 'all')
import nuxt_plugin_axios_72cfea92 from 'nuxt_plugin_axios_72cfea92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_ff5ff9a4 from 'nuxt_plugin_workbox_ff5ff9a4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_63423c41 from 'nuxt_plugin_metaplugin_63423c41' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_67e9e1b5 from 'nuxt_plugin_iconplugin_67e9e1b5' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_slugy_3375ed10 from 'nuxt_plugin_slugy_3375ed10' // Source: ../plugins/slugy (mode: 'all')
import nuxt_plugin_scroller_3c8b6247 from 'nuxt_plugin_scroller_3c8b6247' // Source: ../plugins/scroller.js (mode: 'client')
import nuxt_plugin_infiniteloading_dd65fd44 from 'nuxt_plugin_infiniteloading_dd65fd44' // Source: ../plugins/infinite-loading.js (mode: 'client')
import nuxt_plugin_vuexpersist_25bdab30 from 'nuxt_plugin_vuexpersist_25bdab30' // Source: ../plugins/vuex-persist.js (mode: 'client')
import nuxt_plugin_lazytube_adf7c46e from 'nuxt_plugin_lazytube_adf7c46e' // Source: ../plugins/lazytube.js (mode: 'client')
import nuxt_plugin_youtubeEmbed_707fd68b from 'nuxt_plugin_youtubeEmbed_707fd68b' // Source: ../plugins/youtubeEmbed.js (mode: 'client')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    await delayHydration()
}

  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Upcoming Movies 2024 & New TV Series Streaming Online - Movietube","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"hid":"description","name":"description","content":"Watch Upcoming Movies 2024 & New TV Series Streaming Online"},{"hid":"author","name":"author","content":"Movietube"},{"hid":"og:locale","property":"og:locale","content":"en_US"},{"hid":"og:title","property":"og:title","content":"Movietube App"},{"hid":"og:description","property":"og:description","content":"Upcoming Movies 2024 & New TV Series Streaming Online - Movietube"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fmovietube.online\u002F"},{"name":"og:image","content":"https:\u002F\u002Fmovietube.online\u002Fassets\u002Fimg\u002Flogo-b.png"},{"name":"twitter:card","content":"summary"},{"name":"twitter:title","content":"Movies"},{"name":"twitter:description","content":"Browse Movies, TV Shows and People"},{"name":"twitter:site","content":"@movietubemovies"},{"name":"twitter:creator","content":"@movietubemovies"},{"name":"twitter:image","content":"https:\u002F\u002Fmovietube.online\u002Fassets\u002Fimg\u002Flogo_icon.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.themoviedb.org","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fimage.tmdb.org","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fgoogleads.g.doubleclick.net","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagservices.com\u002F","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fadservice.google.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.youtube.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fimg.youtube.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Ftpc.googlesyndication.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fpagead2.googlesyndication.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.iubenda.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.iubenda.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fhits-i.iubenda.com","crossorigin":true}],"script":[{"lazy-src":"\u002F~partytown\u002Fdebug\u002Fpartytown.js","defer":true},{"lazy-src":"\u002Fjs\u002Fpartytown.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_217e657c === 'function') {
    await nuxt_plugin_plugin_217e657c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_7c032ff2 === 'function') {
    await nuxt_plugin_plugin_7c032ff2(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_f9cec9a8 === 'function') {
    await nuxt_plugin_markdownit_f9cec9a8(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_6c90045e === 'function') {
    await nuxt_plugin_apollomodule_6c90045e(app.context, inject)
  }

  if (typeof nuxt_plugin_image_5dd6e78d === 'function') {
    await nuxt_plugin_image_5dd6e78d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_72cfea92 === 'function') {
    await nuxt_plugin_axios_72cfea92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_ff5ff9a4 === 'function') {
    await nuxt_plugin_workbox_ff5ff9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_63423c41 === 'function') {
    await nuxt_plugin_metaplugin_63423c41(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_67e9e1b5 === 'function') {
    await nuxt_plugin_iconplugin_67e9e1b5(app.context, inject)
  }

  if (typeof nuxt_plugin_slugy_3375ed10 === 'function') {
    await nuxt_plugin_slugy_3375ed10(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scroller_3c8b6247 === 'function') {
    await nuxt_plugin_scroller_3c8b6247(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_dd65fd44 === 'function') {
    await nuxt_plugin_infiniteloading_dd65fd44(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_25bdab30 === 'function') {
    await nuxt_plugin_vuexpersist_25bdab30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazytube_adf7c46e === 'function') {
    await nuxt_plugin_lazytube_adf7c46e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_youtubeEmbed_707fd68b === 'function') {
    await nuxt_plugin_youtubeEmbed_707fd68b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
